import { Box, Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from '@mui/material';
import axios from 'axios';
import React from 'react'
import { Subject } from 'rxjs';
import { FormPane } from '../../../components/FormZero/PageComponents/FormPane/FormPane';
import { IRoute } from '../../../interfaces/Logistics/Route';

type RouteModalProps = {
    loadRoutes: () => Promise<void>,
    showDialog: boolean,
    setShowDialog: (showDialog: boolean) => void
}

export default function AddRouteModalControl(props: RouteModalProps) {
    const { loadRoutes, showDialog, setShowDialog } = props;

    const [formStructure, setFormStructure] = React.useState([
        { key: "name", size: { default: 12 }, type: "text", label: "Route Name" },
        { key: "description", size: { default: 12 }, type: "text", label: "Route Description" },
    ]);
    const [formStructure2, setFormStructure2] = React.useState([
        { key: "customerName", size: { default: 12 }, type: "text", label: "Customer Name" },
        { key: "city", size: { default: 12 }, type: "text", label: "City" },
        { key: "state", size: { default: 12 }, type: "text", label: "State" },
    ]);

    const createRoute = async function () {
        try {
            // const result
            console.log("UPDATED", formValues);
            let route: IRoute = {
                id: 0,
                name: formValues.name,
                description: formValues.description,
                customerLocations: [{ id: 0, customerName: formValues.customerName, state: formValues.state, city: formValues.city }],
                loads: []
            }
            await axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Routes`, route).then(async (resp) => {
                if (resp.status === 201) {
                    await loadRoutes();
                    setShowDialog(false);
                    formSubject.next({});
                } else {
                    console.log(resp);
                }
            });

        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };

    const [formValues, setFormValue] = React.useState<any>({});

    const formSubject = new Subject();
    formSubject.subscribe((v: any) => {
        let data = { ...formValues, ...v };
        setFormValue(data);
    });
    return (
        <Dialog
            open={showDialog}
            onClose={() => setShowDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                Add Route
            </DialogTitle>
            <DialogContent style={{ width: '600px' }}>
                {/*<pre>{JSON.stringify(formValues, undefined, 4)}</pre>*/}
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <div style={{ flex: '1' }}>
                        <Typography variant="h6" component="h4" style={{ width: '100%', textAlign: 'center' }}>
                            Route Info
                        </Typography>
                        <FormPane style={{ width: '100%' }} formStructure={formStructure}
                            formSubject={formSubject} initialFormData={formValues} />
                    </div>
                    <div style={{ flex: '1' }}>
                        <Typography variant="h6" component="h4" style={{ width: '100%', textAlign: 'center' }}>
                            Customer
                        </Typography>
                        <FormPane style={{ width: '100%' }} formStructure={formStructure2}
                            formSubject={formSubject} initialFormData={formValues} />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                {/*<Button onClick={() => downloadReport()} autoFocus text={"Download"} fullWidth={true} />*/}
                <div style={{ display: 'flex', width: '100%', gap: '0.5rem' }}>
                    <div style={{ flexGrow: 1 }}>
                        <Button color='primary' variant='contained' autoFocus onClick={() => setShowDialog(false)} fullWidth><Typography variant="h5" fontWeight="700" sx={{}}>Close</Typography></Button>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        <Button color='secondary' variant='contained' onClick={() => createRoute().then()} autoFocus fullWidth={true} ><Typography variant="h5" fontWeight="700" sx={{}}>Add</Typography></Button>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    )
}
